import strings from '../../Localization/Localization';

let title = {
  fieldKey: "title",
  type: "text",
  label: strings.form.accountVat.title.label,
  validators: []
}

let number = {
  fieldKey: "number",
  type: "text",
  label: strings.form.accountVat.number.label,
  validators: []
}

let vat = {
  fieldKey: "vat",
  type: "text",
  label: strings.form.accountVat.vat.label,
  validators: []
}

export const form = {
  formKey: "accountVat",
  fields: [
    title,
    number,
    vat
  ]
}
